import { useNavigate } from "react-router-dom";
import { Zap } from "lucide-react";
import Reveal from "./Reveal";
import RobotMascot from "./RobotMascot";

const BridgePromo = () => {
  const navigate = useNavigate();
  return (
    <section id="bridge" data-testid="bridge-promo" className="relative py-10 md:py-16">
      <div className="mx-auto max-w-7xl px-5 md:px-10">
        <Reveal>
          <div className="relative overflow-hidden rounded-[2.5rem] border border-[#14D8A5]/30 bg-gradient-to-br from-[#0B1B33] via-[#0B1B33] to-[#062A22] p-8 md:p-16">
            <div className="absolute inset-0 bg-grid opacity-[0.07] invert" aria-hidden="true" />
            <div className="absolute -top-24 right-[-10%] w-96 h-96 rounded-full bg-[#14D8A5]/30 blur-[110px]" aria-hidden="true" />

            <div className="relative grid lg:grid-cols-12 gap-10 items-center">
              <div className="lg:col-span-7">
                <p className="label-mono text-[#14D8A5] mb-4 flex items-center gap-2">
                  <Zap className="w-4 h-4" /> Micro advances · the minute you need them
                </p>
                <h2 className="font-display font-bold tracking-[-0.02em] leading-[1.02] text-white text-4xl md:text-6xl">
                  Small bills?<br />
                  <span className="text-[#14D8A5]">Bridged in minutes.</span>
                </h2>
                <p className="mt-6 max-w-md text-base leading-relaxed text-white/65">
                  The micro advance for small bills: drop in your last 4 months of business bank
                  statements and Robo-B7 auto-approves up to $5,000 on the spot. The contract
                  signs instantly — funds move the same business day.
                </p>
                <div className="mt-8 flex flex-wrap items-center gap-4">
                  <button
                    data-testid="bridge-promo-cta"
                    onClick={() => navigate("/bridge")}
                    className="group inline-flex items-center gap-2.5 rounded-full bg-[#14D8A5] px-8 py-4 text-base font-semibold text-[#0A1628] shadow-[0_12px_32px_rgba(20,216,165,0.4)] transition-all duration-300 hover:bg-white hover:-translate-y-0.5"
                  >
                    Get up to $5,000
                    <Zap className="w-5 h-5 transition-transform group-hover:scale-125" />
                  </button>
                  <span className="label-mono text-white/50">No collateral · no tax returns</span>
                </div>
              </div>

              <div className="lg:col-span-5 flex flex-col items-center gap-6">
                <span className="lr-float-slow inline-block">
                  <RobotMascot className="w-32" dark />
                </span>
                <div className="w-full space-y-3">
                  {[
                    ["01", "Upload 4 statements"],
                    ["02", "Auto-approved up to $5,000 — instantly"],
                    ["03", "Sign the contract · same-day ACH"],
                  ].map(([n, t]) => (
                    <div key={n} className="flex items-center gap-4 rounded-2xl border border-white/10 bg-white/5 backdrop-blur px-5 py-3.5">
                      <span className="mono text-xs text-[#14D8A5]">{n}</span>
                      <span className="text-sm font-medium text-white/85">{t}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default BridgePromo;
